var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClickAndBuysStruct',[_c('div',{staticClass:"uk-grid uk-grid-match uk-child-width-1-2@s uk-child-width-1-1 uk-animation-fade uk-flex-center",attrs:{"uk-grid":""}},_vm._l((_vm.getInfos.clickAndBuys),function(clickAndBuy){return _c('div',{key:clickAndBuy.id},[_c('ClickAndBuyElement',{attrs:{"click-and-buy":clickAndBuy}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }